// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"423":"c3a0c401","545":"e820e371","872":"80e194ce"}[chunkId] + ".css";
};